import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firbase/firebase";
import {
  updateStatsOnCreate,
  updateStatsOnDelete,
} from "../page/admin/dashboard/StatsService";

//! adding jobs
export const addJobs = createAsyncThunk(
  "jobposts/addJobs",
  async (JobsData, { rejectWithValue }) => {
    try {
      const createdAt = serverTimestamp()

      const docRef = await addDoc(collection(db, "jobposts"), {
        ...JobsData,
        createdAt,
      });

      //! for count
      // await updateStatsOnCreate("jobs", new Date());

      // ✅ return createdAt also
      return { id: docRef.id, ...JobsData, createdAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//! fetching jobs
export const fetchJobs = createAsyncThunk(
  "jobposts/fetchJobs",
  async (_, { rejectWithValue }) => {
    try {
      const querySnapshot = await getDocs(collection(db, "jobposts"));
      const jobpost = [];
      querySnapshot.forEach((doc) => {
        jobpost.push({ id: doc.id, ...doc.data() });
      });
      return jobpost;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const updateJobs = createAsyncThunk(
  "jobposts/updateJobs",
  async ({ id, JobsData }, { rejectWithValue }) => {
    try {
        const updatedAt = serverTimestamp()

      const jobRef = doc(db, "jobposts", id);
      await updateDoc(jobRef, {
        ...JobsData,
        updatedAt, // ✅ add this
      });

      // ✅ return updatedAt so Redux state is correct
      return { id, ...JobsData, updatedAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//! delete job
export const deleteJobs = createAsyncThunk(
  "jobsposts/deleteJobs",
  async (id, { rejectWithValue }) => {
    console.log("deleteJobs thunk STARTED with id:", id);
    try {
      const jobRef = doc(db, "jobposts", id);
      console.log("Job ref created:", jobRef.path);
      
      // 1️⃣ Get job data first
      const snap = await getDoc(jobRef);
      console.log("Document snapshot exists:", snap.exists());

      if (!snap.exists()) {
        throw new Error("Job not found");
      }

      const jobData = snap.data();
      console.log("Job data retrieved:", jobData);

      // 2️⃣ Delete job
      await deleteDoc(jobRef);
      return id;
    } catch (error) {
      console.log("deleteJobs thunk ERROR:", error);
      return rejectWithValue(error.message);
    }
  },
);

export const JobSlice = createSlice({
  name: "jobs",
  initialState: {
    jobs: [],
    loading: {
      add: false,
      fetch: false,
      update: false,
      delete: false,
    },
    error: null,
    editjob: null,
  },
  reducers: {
    setEditjobdata: (state, action) => {
      // debugger;
      state.editjob = action.payload;
    },
    clearEditingJob: (state) => {
      state.editjob = null;
    },
  },

  extraReducers: (builder) => {
    builder
      //! add job posts
      .addCase(addJobs.pending, (state) => {
        state.loading.add = true;
      })
      .addCase(addJobs.fulfilled, (state, action) => {
        state.loading.add = false;
        state.jobs.push(action.payload);
      })
      .addCase(addJobs.rejected, (state, action) => {
        state.loading.add = false;
        state.error = action.payload;
      })

      //! fetch jobs
      .addCase(fetchJobs.pending, (state) => {
        state.loading.fetch = true;
        state.error = null;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.loading.fetch = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.loading.fetch = false;
        state.error = action.payload;
      })

      //! update jobs
      .addCase(updateJobs.pending, (state) => {
        state.loading.update = true;
        state.error = null;
      })
      .addCase(updateJobs.fulfilled, (state, action) => {
        state.loading.update = false;
        const index = state.jobs.findIndex(
          (job) => job.id === action.payload.id,
        );
        if (index !== -1) {
          state.jobs[index] = { ...state.jobs[index], ...action.payload };
        }
        state.editjob = null;
      })
      .addCase(updateJobs.rejected, (state, action) => {
        state.loading.update = false;
        state.error = action.payload;
      })

      //! delete jobs
      .addCase(deleteJobs.pending, (state) => {
        state.loading.delete = true;
      })
      .addCase(deleteJobs.fulfilled, (state, action) => {
        state.loading.delete = false;
        state.jobs = state.jobs.filter((job) => job.id !== action.payload);
      })
      .addCase(deleteJobs.rejected, (state, action) => {
        state.loading.delete = false;
        state.error = action.payload;
      });
  },
});

export const { setEditjobdata, clearEditingJob } = JobSlice.actions;

export default JobSlice.reducer;
